import { ChartOption, ReportResult } from "../entities/reportEntity";
import { isEmpty } from "@/utils/Common";
import { WORLD_MAPPING } from "./data/world";

import "echarts/map/js/world";

export default function (definition: any, chartOption: ChartOption, datas: ReportResult) {
  const cnMap: any = {};
  for (const key in WORLD_MAPPING) {
    cnMap[WORLD_MAPPING[key].cn] = key;
  }

  const geoData: Array<any> = [];
  let maxCount = 0;
  for (let j = 0; j < datas.rowCount; j++) {
    if (datas.rowDimNodes[j][0].total) {
      continue;
    }

    let count = 0;
    if (datas.dataValues[datas.rowColIndexes[j][0]]) {
      count = datas.dataValues[datas.rowColIndexes[j][0]][0];
    }
    if (count > maxCount) {
      maxCount = count;
    }

    const country = datas.rowDimNodes[j][0].label;
    geoData.push({
      name: cnMap[country] || country,
      value: count,
    });
  }

  const option: any = {
    tooltip: {
      formatter: function (params: any) {
        const cuntry: any = WORLD_MAPPING[params.name] ? WORLD_MAPPING[params.name].cn : params.name;
        return "申请量<br>" + cuntry + ": " + (params.value || 0);
      },
    },
    visualMap: {
      min: 0,
      max: maxCount,
      text: ["高", "低"],
      realtime: false,
      calculable: true,
      inRange: {
        color: ["#fffffe", "#006edd"],
      },
    },
    geo: {
      map: "world",
      roam: true,
      label: {
        normal: {
          show: false,
        },
        emphasis: {
          show: false,
        },
      },
      itemStyle: {
        normal: {
          borderColor: "rgba(0, 0, 0, 0.2)",
        },
        emphasis: {
          areaColor: null,
          shadowOffsetX: 0,
          shadowOffsetY: 0,
          shadowBlur: 20,
          borderWidth: 0,
          shadowColor: "rgba(0, 0, 0, 0.5)",
        },
      },
    },
    series: [
      {
        name: "申请量",
        type: "map",
        roam: true,
        coordinateSystem: "geo",
        geoIndex: 0,
        label: {
          normal: {
            show: false,
          },
          emphasis: {
            show: false,
          },
        },
        itemStyle: {
          normal: {
            color: "#F06C00",
          },
        },
        data: geoData,
      },
    ],
  };

  if (!chartOption.hideTitle && !isEmpty(chartOption.title)) {
    option.title = {
      left: "center",
      text: chartOption.title,
    };
    if (!isEmpty(chartOption.subTitle)) {
      option.title.subtext = chartOption.subTitle;
    }
  }

  if (!chartOption.hideToolbox) {
    option.toolbox = {
      show: true,
      feature: {
        saveAsImage: {},
      },
    };
  }

  return option;
}
